var table_viewer_default = {
  "viewMode": "FkRJm",
  "editMode": "xEb2-",
  "container": "rc0lZ",
  "cell": "dgW4K"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
